import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { useLanguage } from '../contexts/LanguageContext';
import apiInstance from '../utils/axios';

const ViewAllProducts = () => {
  const { t } = useLanguage();
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await apiInstance.get('produtos-populares/');
        let products = [];
        if (Array.isArray(response.data)) {
          products = response.data;
        } else if (Array.isArray(response.data.results)) {
          products = response.data.results;
        }
        setFeaturedProducts(products.slice(0, 6));
      } catch (error) {
        // Optionally log error in dev only
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, []);

  if (loading) {
    return (
      <section className="py-10 md:py-16">
        <div className="mx-auto max-w-7xl px-4">
          <div className="h-48 md:h-64 rounded-xl bg-secondary animate-pulse mb-8" />
          <div className="grid grid-cols-3 md:grid-cols-6 gap-3 md:gap-4 mb-8">
            {[...Array(6)].map((_, i) => (
              <div key={i} className="aspect-square rounded-lg bg-secondary animate-pulse" />
            ))}
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-10 md:py-16">
      <div className="mx-auto max-w-7xl px-4">
        {/* Banner Image */}
        <div className="relative w-full h-48 md:h-64 rounded-xl overflow-hidden mb-8 bg-gradient-to-r from-primary to-accent">
          <div className="absolute inset-0 bg-foreground/40" />
          <div className="absolute inset-0 flex items-center justify-center">
            <h2 className="text-2xl md:text-4xl font-bold text-card text-center text-balance px-4">
              {t('exploreCollection') || 'Explore Nossa Coleção Completa'}
            </h2>
          </div>
        </div>

        {/* Product Grid Preview */}
        {featuredProducts.length > 0 && (
          <div className="grid grid-cols-3 md:grid-cols-6 gap-3 md:gap-4 mb-8">
            {featuredProducts.map((product) => (
              <Link
                key={product.id || product.pid}
                to={`/detail/${product.slug || product.id}`}
                className="relative aspect-square rounded-lg overflow-hidden bg-secondary group"
              >
                <img
                  src={product.image || '/placeholder.jpg'}
                  alt={product.title_translated || product.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </Link>
            ))}
          </div>
        )}

        {/* CTA Section */}
        <div className="text-center">
          <p className="text-muted-foreground mb-4 text-sm md:text-base">
            {t('moreProductsAvailable') || 'Mais de 1.000 produtos disponíveis com os melhores preços'}
          </p>
          <Link to="/products">
            <Button size="lg" className="px-8">
              {t('viewAllProducts')}
              <ArrowRight className="h-5 w-5 ml-2" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ViewAllProducts;
